(ns fablo-offers.app.components.riverview
  (:require ["@chakra-ui/react" :as ch]
            ["@iconify/react" :as iconify]
            ["framer-motion" :as fm]
            ["react-final-form" :as rff]
            ["react-i18next" :refer [Trans]]
            ["react-icons/fa" :as icons]
            ["react-icons/fi" :refer [FiCalendar FiChevronLeft FiChevronRight
                                      FiClock FiPhone FiUsers]]
            ["react-qr-code" :as qr]
            [applied-science.js-interop :as j]
            [cljs-bean.core :refer [->clj] :as bean]
            [clojure.string :as string]
            [fablo-offers.app.components.app :as app]
            fablo-offers.app.components.form
            [fablo-offers.common.api :as api]
            [fablo-offers.common.components.forms :as form]
            [fablo-offers.common.constants :as constants]
            [fablo-offers.common.lib.hooks :as hooks]
            [fablo-offers.common.lib.i18n :as i18n]
            [fablo-offers.common.state :as s]
            [fablo-offers.common.tracking :refer [use-track]]
            [promesa.core :as p]
            [rumext.alpha :as mf]
            [tick.core :as tick]
            [tick.locale-en-us]))

(i18n/add-translations
 :en
 :riverview
 {:accept-required "Accept is required"
  :date-locale "en-EN"
  :next "NEXT"
  :back "BACK"
  :confirm "CONFIRM"
  :click-confirm-and-order "Click 'Confirm and order' to make the reservation."
  :click-confirm-and-pay "Click 'Order and pay' to make the reservation."
  :welcome
  {:msg "Dear guests,\n we kindly request you to make a\u00A0reservation for the swimming pool"
   :img-desc "Make\n a reservation"}
  :adults "Adults"
  :kids "Children"
  :date "Date"
  :time "Time"
  :room "Room"
  :duration "Visit duration"
  :date-header "Select a day:"
  :time-header "Choose a starting time and visit duration:"
  :time-picker-header "Click on the tiles to specify visit duration:"
  :duration-header "Visit duration:"
  :terms-link "Help"
  :select "Select"
  :date-required "Select day"
  :time-required "Select time"
  :places-available "spots available"
  :few-spots-left "few spots left"
  :free-pool-info "* You have already used 1 hour per room per day for the selected day. Please contact the RiverView reception for clarification."
  :no-spots-left "no spots left"
  :terms
  {:text1 "Pool reservations can be made by"
   :item1 "Checked-in hotel guests"
   :item2 "Voucher holders"
   :par1 "Read our regulations"
   :rv-link "RiverView Wellness Centre"
   :par2 "If you need assistance or additional information, please contact us:"}
  :limit-modal
  {:header "Multiple reservations policy"
   :par1 "During one hotel day, guests may visit the swimming pool a maximum of 2 times"
   :par2 "First visit: before 14:00\n Second visit: after 14:00"}
  :confirm-header "Confirm your visit:"
  :whats-room "What's your room number?"
  :whats-name "What's your ful name?"
  :dont-have-room "I don't have a room number"
  :have-room "I have a room number"
  :name-placeholder "Your Name"
  :room-name-required "Please enter your name or room number"
  :room-incorrect "Please enter correct room number"
  :taken-error-title "We are sorry, requested number of places is no longer available."
  :taken-error-body "Try to choose a different hour."
  :thx
  {:header "Success!<br/> Reservation is done"
   :par1 "Provide entered room number or name at the reception desk and enjoy your visit!"
   :par2 "Any questions about your reservation or want to make changes?"}
  :pricing
  {:hotel-guests "Hotel guets"
   :voucher "Voucher holders"
   :included "included in the price"
   :included-guest "1 h daily per room"
   :included-voucher "3h"
   :next-hour "every next hour"}
  :summary "Reservation summary:"
  :busy "High"
  :occupancy "Usage"
  :not-busy "Low"})

(i18n/add-translations
 :pl
 :riverview
 {:accept-required "Akceptacja wymagana"
  :date-locale "pl-PL"
  :next "DALEJ"
  :back "WRÓĆ"
  :confirm "POTWIERDŹ"
  :click-confirm-and-order "Kliknij 'Potwierdzam i zamawiam', aby złożyć rezerwację."
  :click-confirm-and-pay "Kliknij 'Zamawiam i płacę', aby złożyć rezerwację."
  :welcome
  {:msg "Szanowni goście,\n uprzejmie prosimy o\u00A0dokonanie rezerwacji na\u00A0basen"
   :img-desc "Zarezerwuj\n miejsce"}
  :adults "Dorośli"
  :kids "Dzieci"
  :date "Data"
  :time "Godzina"
  :room "Pokój"
  :duration "Czas rezerwacji"
  :date-header "Wybierz dzień:"
  :duration-header "Czas trwania wizyty:"
  :time-header "Wybierz godzinę i czas trwania wizyty:"
  :time-picker-header "Klikaj w kolejne kafelki, żeby określić czas trwania wizyty:"
  :terms-link "Pomoc"
  :select "Wybierz"
  :date-required "Wybierz dzień"
  :time-required "Wybierz godzinę"
  :places-available "wolne miejsca"
  :few-spots-left "mało miejsc"
  :free-pool-info "* Na wybrany dzień masz już wykorzystaną 1 h na pokój dziennie. Zgłoś się do recepcji RiverView
w celu wyjaśnienia."
  :no-spots-left "brak miejsc"
  :terms
  {:text1 "Rezerwacji na basen mogą dokonywać:"
   :item1 "Zameldowani goście hotelowi"
   :item2 "Posiadacze vouchera"
   :par1 "Sprawdź regulamin"
   :rv-link "RiverView Wellness Centre"
   :par2 "Jeśli potrzebujesz pomocy lub dodatkowych informacji, skontaktuj się z nami:"}
  :limit-modal
  {:header "Zasady dla wielu rezerwacji"
   :par1 "W ciągu jednej doby hotelowej, goście mogą skorzystać z basenu maksimum 2 razy:"
   :par2 "Pierwsza wizyta: przed 14:00\n Druga wizyta: po 14:00"}
  :confirm-header "Potwierdź wizytę:"
  :whats-room "Wpisz numer swojego pokoju"
  :whats-name "Podaj imię i nazwisko"
  :dont-have-room "Nie mam przydzielonego pokoju"
  :have-room "Mam przydzielony pokój"
  :name-placeholder "Imię i nazwisko"
  :room-name-required "Podaj numer pokoju lub imię i nazwisko"
  :room-incorrect "Popraw numer pokoju"
  :taken-error-title "Przepraszamy, żądana liczba miejsc jest już niedostępna."
  :taken-error-body "Spróbuj wybrać inną godzinę."
  :thx
  {:header "Dziękujemy!<br/> Wizyta zarezerwowana"
   :par1 "Podaj wskazane imię i nazwisko lub numer pokoju na recepcji basenu. Życzymy udanego pobytu!"
   :par2 "Aby zmienić rezerwację lub dowiedzieć się więcej, prosimy o kontakt:"}
  :pricing
  {:hotel-guests "Goście hotelowi"
   :voucher "Voucher"
   :included "w cenie"
   :included-guest "1h dziennie na pokój"
   :included-voucher "3h"
   :next-hour "każda kolejna godzina"}
  :summary "Podsumowanie rezerwacji:"
  :busy "Duży"
  :occupancy "Ruch"
  :not-busy "Mały"})

;; (def theme
;;   (ch/extendTheme
;;    (clj->js
;;     {:colors
;;      {:brand {:500 "#183448"}}
;;      :components
;;      {:Heading
;;       {:baseStyle
;;        {:color "brand.500"}}
;;       :Button
;;       {:variants {}}}})))

(mf/defc hover-tap-animate [{:keys [children]}]
  [:> fm/motion.div
   {:while-hover {:scale 1.05}
    :while-tap {:scale 0.95}}
   children])

(mf/defc logo [props]
  [:& ch/Image (assoc props :src "/riverview/logo.png")])

(mf/defc lang-button []
  [:> ch/Button
   {:variant
    :ghost
    :h "16px"
    :on-click #(i18n/change-language! (if (= (i18n/language) "pl") "en" "pl"))}
   (if (= "pl" (i18n/language))
     "ENGLISH >"
     "POLISH >")])

(mf/defc description [{:keys [show-form]}]
  (let [t (hooks/use-t "riverview")]
    (use-track "Riverview welcome page" {})
    [:> ch/Box
     {:bg "url(/riverview/pool/photo.jpg)"
      :background-size "cover"}
     [:> ch/Flex {:direction :column
                  :align :center
                  :justify :space-around
                  :min-h "calc(100vh - 80px)"
                  :bg "linear-gradient(0deg, rgba(0, 0, 0, 0.07) 0%, rgba(0, 0, 0, 0.07) 100%), linear-gradient(0deg, rgba(15, 46, 80, 0.56) 0%, rgba(15, 46, 80, 0.56) 100%)"}

      [:> ch/Box {}]

      [:> ch/Box {:text-align :center}
       [:> ch/Heading
        {:align :center
         :font-size "30px"
         :line-height "1.2em"
         :font-weight 800
         :white-space :pre-wrap
         :my 4
         :color :white
         :max-w "300px"}
        [:> Trans {} "riverview:welcome.msg"]]

       [:> ch/Box {:display :inline-block}
        [:& iconify/Icon
         {:icon "material-symbols:pool"
          :color "white"
          :width 72
          :height 72}]]]

      [:> ch/Button
       {:color-scheme :white
        :bg :white
        :color :brand.500
        :font-family "Abhaya Libre,'Open Sans',sans-serif"
        :font-weight 800
        :on-click show-form
        :font-size :2xl
        :px 8
        :mb 16
        :h "72px"
        :size :lg
        :white-space :pre-wrap}
       (t "welcome.img-desc")]]]))

(mf/defc offer-form [params]
  [:& form/form
   {:initial-values {}
    :on-submit (fn [values]
                 (js/console.log params values)
                 #_(try
                     (dispatch :submit (->clj values))
                     (catch ToastError ^ToastError e
                       (toast #js {:title (.-msg e)
                                   :status "error"}))))}
   (app/render-cmp params)])

(defn slot-day-formatter [locale date]
  (let [[day a b]
        (->
         (js/Intl.DateTimeFormat
          locale
          #js {:month "long"
               :weekday "long"
               :day "numeric"})
         (.format (js/Date. date))
         (string/split #",? "))]
    (if (= locale "pl-PL") ;; fixme
      [day a b]
      [day b a])))

(defn slot-day-formatter2 [locale date]
  (->
   (js/Intl.DateTimeFormat
    locale
    #js {:month "long"
         :weekday "short"
         :day "numeric"})
   (.format (js/Date. date))))

(mf/defc calendar-slider
  [{:keys [page dir children]}]
  [:> fm/AnimatePresence
   {:custom dir
    :initial false}
   [:> fm/motion.div
    {:key page
     :custom dir
     :variants
     (clj->js
      {:enter (fn [dir]
                #js {:x (* dir 300)
                     :opacity 0
                     :position "absolute"
                     :width "100%"})
       :exit (fn [dir]
               #js {:x (* dir -300)
                    :opacity 0
                    :position "absolute"
                    :width "100%"
                    :zIndex 0})
       :center {:zIndex 1
                :x 0
                :position "absolute"
                :width "100%"
                :opacity 1}})
     :initial "enter"
     :animate "center"
     :exit "exit"
     :transition
     {:x {:type "spring" :stiffness 300 :damping 30}
      :opacity {:duration 0.2}}}
    children]])

(mf/defc day-picker [{:keys [days]}]
  (let [t (hooks/use-t "riverview")
        form (rff/useForm)
        days (mf/with-memo
               [(t "date-locale")]
               (->> days
                    (map :day)
                    (filter #(tick/<= (tick/date) (tick/date %)))
                    (mapv (fn [d]
                            {:value d
                             :labels
                             (slot-day-formatter (t "date-locale") d)}))))

        pagination-state (mf/use-state [0 0])
        pages-num (/ (count days) 3)
        [page dir] @pagination-state
        change-page! (fn [dir]
                       (when (<= 0 (+ page dir) (dec pages-num))
                         (reset! pagination-state [(+ page dir) dir])))

        days-subset (subvec days (* 3 page) (* 3 (inc page)))]

    [:> ch/Flex
     {:w :full
      :align :center
      :justify :space-between}
     [:> ch/Button
      {:on-click #(change-page! -1)
       :variant :ghost
       :px 2
       :color-scheme :brand}
      [:> ch/Icon {:as FiChevronLeft :font-size :xl}]]
     [:> ch/Flex {:h "100px" :flex 1 :min-w "220px" :max-width "316px" :position :relative :justify :center}
      [:& calendar-slider {:dir dir :page page}
       [:& form/field
        {:name [:main :day]
         :validate (fn [x] (when-not x [(t "date-required")]))
         :component
         (mf/fnc
          slot-day [props]
          [:& form/box-radio
           (merge
            props
            {:items days-subset
             :container-render ch/HStack
             :item-render
             (mf/fnc item-render
                     [{:keys [item props]}]
                     (let [[weekday day month] (:labels item)]
                       (j/assoc!
                        props
                        :rounded "2xl"
                        :border "1px solid var(--chakra-colors-brand-500)"
                        :px 1
                        :py 2
                        :mx 1
                        :maxWidth "100px"
                        :minWidth "70px"
                        :flex 1
                        :textAlign "center"
                        :cursor "pointer"
                        :color "brand.500"
                        :_checked #js {:color "#fff"
                                       :backgroundColor "var(--chakra-colors-brand-500)"}
                        :onClick (fn []
                                   (js/setTimeout
                                    (fn []
                                      (.change form "main.time" nil)
                                      (.change form "main.duration" nil))
                                    20)
                                   true))
                       [:> ch/Box
                        props

                        [:> ch/Text
                         {:font-size :sm
                          :font-family "Abhaya Libre"
                          :font-weight "800"}
                         weekday]
                        [:> ch/Text
                         {:font-size :4xl
                          :font-weight "500"
                      ;:color :gray.500
                          :line-height "1em"}
                         day]
                        [:> ch/Text
                         {:font-size :sm
                          :font-family "Abhaya Libre"
                          :font-weight "800"}
                         month]]))})])}]]]
     [:> ch/Button
      {:on-click #(change-page! 1)
       :variant :ghost
       :px 2
       :color-scheme :brand}
      [:> ch/Icon {:as FiChevronRight :font-size :xl}]]]))

(defn format-duration [duration]
  (let [h (quot duration 60)
        m (mod duration 60)]
    (str h ":" (if (zero? m) "0" "") m)))

(defn format-duration2 [duration]
  (if (or (not duration) (zero? duration))
    "0 h 0 min"
    (let [h (quot duration 60)
          m (mod duration 60)]
      (str
       (when (pos? h)
         (str h " h "))
       (when (pos? m)
         (str m " min "))))))

(defn format-duration-sec [duration]
  (let [h (quot duration (* 60 60))
        m (mod (quot duration 60) 60)
        s (mod duration 60)]
    (str
     (when (pos? h)
       (str h " h "))
     (when (or (pos? m) (zero? duration))
       (str m " min "))
     (when (and (zero? h) (pos? s))
       (str s " sec")))))

(def colors
  {:green "#2E8540"
   :orange "#E07400"
   :red "#DC143C"
   :black "#000000"})

(defn slot-color [limit persons]
  (cond
    (< limit persons) (:black colors)
    (<= limit 2) (:red colors)
    (<= limit 5) (:orange colors)
    :else (:green colors)))

(defn chart-bar-color [people]
  (cond
    (<= people 20) (:green colors)
    (<= people 30) (:orange colors)
    :else (:red colors)))

(defn format-slot-time
  "Given slot time as HH:mm string, cuts leading zero
  and rounds the time up to full hour."
  [slot-time]
  (string/replace
   (if (= "0" (first slot-time))
     (subs slot-time 1)
     slot-time)
   #"30"
   "00"))

(mf/defc slots-chart [{:keys [data]}]
  (let [chart-height 52
        max-val (apply max (map second data))
        domain-max (max max-val chart-height)
        scale (/ chart-height domain-max)
        bar-width "4.5%"
        t (hooks/use-t "riverview")]
    [:> ch/HStack {:w :full :align :stretch}
     [:> ch/VStack
      {:w "32px"
       :h (str chart-height "px")
       :justify :space-between}
      [:> ch/Text {:font-size :xs :color (:red colors) :line-height 1} (t "busy")]
      [:> ch/Text {:font-size :xs :color (:black colors) :line-height 1} (t "occupancy")]
      [:> ch/Text {:font-size :xs :color (:green colors) :line-height 1} (t "not-busy")]]
     [:> ch/Box {:flex 1 :mr "32px"}
      [:> ch/HStack
       {:h (str chart-height "px")
        :gap 2
        :align :flex-end}
       (for [[_slot-time people] data
             :let [height (js/Math.round (* people scale))]]
         [:> ch/Box
          {:w bar-width
           :rounded-top :sm
           :h (str height "px")
           :bg (chart-bar-color people)}])]
      [:> ch/Spacer {:mt 0.5}]
      [:> ch/HStack {:gap 2}
       (for [[slot-time _people] data]
         [:> ch/Text
          {:w bar-width :font-size :xs :white-space :nowrap}
          (if-not (some #{slot-time} ["07:30" "12:30" "16:30" "21:30"])
            ""
            (format-slot-time slot-time))])]]]))

(mf/defc contact-links []
  [:> ch/Text {}
   [:> ch/Link {:font-weight :bold :text-decoration :underline :color :brand.500 :href "tel:+48223288640"}
    [:b "+48 (22) 328 86 40"]]
   [:br]
   [:> ch/Link {:font-weight :bold :text-decoration :underline :color :brand.500 :href "mailto:riverview@ihg.com"}
    [:b "riverview@ihg.com"]]])

(mf/defc slot-not-available-info []
  (let [t (hooks/use-t "riverview")]
    [:> ch/Popover
     {:placement "right"
      :trigger "hover"}
     [:> ch/PopoverTrigger {}
      [:> ch/Box {}
       [:> ch/Icon {:as icons/FaInfoCircle :color "#0F2E50" :cursor "pointer"}]]]
     [:> ch/PopoverContent {}
      [:> ch/PopoverBody
       {:bg "#E0F1FE"
        :text-align :center}
       [:> ch/Text
        {:color :brand.500
         :font-weight 600}
        (t {:en "We apologize, there are no places available in this slot."
            :pl "Przepraszamy, w wybranym slocie nie ma miejsc."})]
       [:> ch/Text
        {:color :brand.500
         :font-size :sm}
        (t {:en "We are here for you. Contact us, we will find a solution."
            :pl "Jesteśmy tu dla Ciebie. Skontaktuj się z nami, znajdziemy rozwiązanie."})
        [:& contact-links {}]]]]]))

(mf/defc not-for-vip [{:keys [children]}]
  (let [{:keys [preorder-summary]} (mf/use-ctx fablo-offers.app.components.form/offer-ctx)]
    (when-not (:is-vip? preorder-summary)
      children)))

(defn slot-availability-limited-for-voucher? [slot]
  (let [date (tick/date (:day slot))
        last-voucher-time (condp = (tick/day-of-week date)
                            #time/day-of-week "FRIDAY" "15:00"
                            #time/day-of-week "SATURDAY" "15:00"
                            #time/day-of-week "SUNDAY" "15:00"
                            nil)
        first-voucher-time (condp = (tick/day-of-week date)
                             #time/day-of-week "SUNDAY" "12:00"
                             nil)]
    (and
     (tick/> date #time/date "2025-07-20")
     (not
      (and
       (or (nil? last-voucher-time) (<= (compare (:time slot) last-voucher-time) 0))
       (or (nil? first-voucher-time) (>= (compare (:time slot) first-voucher-time) 0)))))))

(mf/defc time-slot-modal
  [{:keys [opened on-close slots set-value value persons kids voucher? slots-chart-data]}]
  (let [mobile? (first (ch/useMediaQuery "(max-width: 600px)"))
        t (hooks/use-t "riverview")
        start (some-> (:start value) tick/time)
        default-duration (if voucher? 180 60)
        slot-duration 30
        duration (:duration value slot-duration)]
    [:> ch/Modal
     {:is-open opened
      :on-close on-close
      :size (if mobile? "full" "md")}
     [:> ch/ModalOverlay {}]
     [:> ch/ModalContent
      {:flex 1
       :min-h "200px"
       :max-h "100svh"
       :justify-self :stretch
       :margin 0}

      [:> ch/ModalHeader {}
       [:> ch/Heading {:size :md :text-align :center :mb 4}
        (t "time-picker-header")]
       [:& slots-chart {:data slots-chart-data}]]

      [:> ch/ModalCloseButton {}]
      [:> ch/ModalBody {:flex 1 :min-h "200px" :flex-direction :column :display :flex}

       [:> ch/VStack
        {:overflow :scroll
         :flex 1
         :min-h "100px"}

        (let [end-time (and start (tick/>> start (tick/new-duration (- duration slot-duration) :minutes)))
              last-time (some-> (:label (last slots)) tick/time)
              slot-available? (fn [slot capacity-limit]
                                (let [kids-limit? (and (pos? kids)
                                                       (>= (compare (:label slot) "19:00") 0))]
                                  (and (>= capacity-limit persons)
                                       (not kids-limit?))))
              find-next-unavailable-time (fn [current-time]
                                           (some->> slots
                                                    (filter #(tick/> (tick/time (:label %)) current-time))
                                                    (remove slot-available?)
                                                    first
                                                    :label
                                                    tick/time))]
          (when last-time
            (for [s slots
                  :let [slot-time (tick/time (:label s))
                        active? (and start (tick/<= start slot-time end-time))
                        last-active? (and start (tick/= slot-time end-time))
                        next-unavailable-time (find-next-unavailable-time slot-time)
                        max-duration-base (+ (tick/between slot-time last-time :minutes) slot-duration)
                        max-duration (if next-unavailable-time
                                       (min max-duration-base
                                            (tick/between slot-time next-unavailable-time :minutes))
                                       max-duration-base)
                        availability (:availability s)
                        capacity-limit (if voucher?
                                         (:voucher availability)
                                         (:hotel availability))
                        kids-limit? (and (pos? kids)
                                         (>= (compare (:label s) "19:00") 0))
                        available? (slot-available? s capacity-limit)
                        hidden? (and voucher?
                                     (slot-availability-limited-for-voucher? s))]]
              (when-not hidden?
                [:*
                 [:> ch/HStack
                  {:pr 6
                   :w "100%"}
                  [:> ch/Box {:w 6}
                   (when (and (not available?)
                              (not voucher?)
                              (not kids-limit?))
                     [:> slot-not-available-info {}])]
                  [:> ch/Flex
                   {:flex 1
                    :rounded "md"
                    :border "1px solid var(--chakra-colors-brand-500)"
                    :border-color (when-not available? "#D1D1D1")
                    :px 4
                    :py 3
                    :cursor "pointer"
                    :align :center
                    :text-align :center
                    :on-click #(when available?
                                 (cond
                                 ;; only one slot and clicked
                                   (and active? (= duration slot-duration)) nil

                                 ;; empty selection
                                   (not start)
                                   (set-value {:start (:label s)
                                               :duration (min max-duration default-duration)})

                                 ;; move start
                                   (tick/<= (tick/<< start (tick/new-duration slot-duration :minutes))
                                            slot-time
                                            (tick/>> start (tick/new-duration (dec (/ duration 2)) :minutes)))
                                   (let [new-start (if active?
                                                     (tick/>> slot-time (tick/new-duration slot-duration :minutes))
                                                     slot-time)]
                                     (set-value {:start (str new-start)
                                                 :duration (+ duration (tick/between new-start start :minutes))}))

                                 ;; move end
                                   (tick/<= (tick/>> start (tick/new-duration (/ duration 2) :minutes))
                                            slot-time
                                            (tick/>> start (tick/new-duration duration :minutes)))
                                   (set-value {:start (str start)
                                               :duration (+ (if active? 0 slot-duration)
                                                            (tick/between start slot-time :minutes))})

                                 ;; outside + 1 clicked
                                   :else
                                   (let [duration (min max-duration default-duration)
                                         new-end (tick/>> slot-time (tick/new-duration duration :minutes))
                                         new-duration-slots (filter (fn [slot]
                                                                      (and (tick/>= (tick/time (:time slot)) slot-time)
                                                                           (tick/<= (tick/time (:time slot)) new-end)))
                                                                    slots)
                                         include-unavailable-slots? (some (fn [slot]
                                                                            (not (>= (if voucher?
                                                                                       (:voucher (:availability slot))
                                                                                       (:hotel (:availability slot)))
                                                                                     persons)))
                                                                          new-duration-slots)]
                                     (when-not include-unavailable-slots?
                                       (set-value {:start (:label s)
                                                   :duration duration})))))
                    :background-color (when active? "var(--chakra-colors-brand-500)")
                    :color (when active? "#fff")}
                   [:> ch/Box
                    {:flex 1
                     :font-size "30px"
                     :font-weight 500
                     :color (when-not available? "#D1D1D1")}
                    (:label s)]
                   [:> ch/Box
                    {:flex 1
                     :color (if active? "#fff" (slot-color capacity-limit persons))}
                    [:> ch/Text
                     {:color "inherit"
                      :font-weight 800
                      :font-family "var(--chakra-fonts-heading)"}
                     (cond (< capacity-limit persons)
                           (t "no-spots-left")
                           (<= capacity-limit 5)
                           (t "few-spots-left")
                           :else
                           (t "places-available"))]
                    [:> ch/Text
                     {:font-size "30px"
                      :line-height "1em"
                      :color "inherit"}
                     (if (> capacity-limit 10) "10+" (.toFixed capacity-limit 0))]]]]
                 (when last-active?
                   [:> ch/Text {:font-weight 500 :text-align :center :px 6 :font-size "12px"}
                    (t {:pl "1 slot to 30 min. Wybierz kolejne sloty, wyżej lub niżej, żeby określić długość wizyty."
                        :en "1 slot is 30 min. Select additional slots, above or below, to specify visit duration."})])]))))]

       [:> ch/VStack
        {:w :full
         :px 8}
        [:> ch/HStack
         {:align :center
          :justify :space-between
          :w :full
          :mt 4
          :px 1
          :py "2px"
          :rounded :md
          :bg (when (:duration value) "#E0F1FE")}
         [:> ch/Text {} (t "duration-header")]
         [:> ch/Text {:font-weight 700 :my 1} (format-duration2 (:duration value 0))]]
        [:& not-for-vip {}
         (when (and (not voucher?)
                    (> (:duration value 0) 60))
           [:> ch/Text {:color "#E07400" :font-weight 500 :font-size :sm}
            [:> ch/Icon {:as icons/FaInfoCircle :mr 2 :font-size "1.2em" :vertical-align :middle}]
            (t {:pl "W cenie 1h dziennie na pokój. Każda kolejna godzina: 50 pln."
                :en "1h per room daily included in the price. Every next hour: 50 pln."})])
         (when (and voucher?
                    (> (:duration value 0) 180))
           [:> ch/Text {:color "#E07400" :font-weight 500 :font-size :sm}
            [:> ch/Icon {:as icons/FaInfoCircle :mr 2 :font-size "1.2em" :vertical-align :middle}]
            (t {:pl "W cenie vouchera są 3h. Każda kolejna: 50 pln."
                :en "Voucher includes 3h. Every next hour: 50 pln."})])]]]

      [:> ch/ModalFooter {:justify-content :center}
       [:> ch/Button
        {:on-click on-close
         :size :lg
         :color-scheme :brand}
        "Ok"]]]]))

(mf/defc limit-modal [{:keys [opened on-close]}]
  (let [t (hooks/use-t "riverview")]
    [:> ch/Modal
     {:is-open opened
      :on-close on-close}
     [:> ch/ModalOverlay {}]
     [:> ch/ModalContent {}
      [:> ch/ModalHeader {}]
      [:> ch/ModalCloseButton {}]
      [:> ch/ModalBody {:text-align :center :px 16 :pb 8}
       [:> ch/Text {:mb 4 :color :brand.500} [:b (t "limit-modal.header")]]
       [:> ch/Text {:mb 4 :color :orange.500} (t "limit-modal.par1")]
       [:> ch/Text {:mb 8 :white-space :pre-wrap} (t "limit-modal.par2")]
       [:> ch/Button
        {:on-click on-close
         :size :lg
         :colorScheme "brand"
         :w "150px"}
        "OK"]]]]))

(defn visible-slot?
  [guest-type slot]
  (let [to-hide (case guest-type
                  "hotel" #{:total :hotel}
                  "voucher" #{:total :voucher}
                  #{})]
    (not (contains? to-hide (:hidden-for slot)))))

(mf/defc time-slot-picker [{:keys [days slots-chart-data]}]
  (let [modal? (mf/use-state false)
        form (rff/useForm)
        set-value (fn [{:keys [start duration]}]
                    (.change form "main.time" start)
                    (.change form "main.duration" duration))
        form-state (->clj (rff/useFormState))
        values (:main (:values form-state))
        {:keys [day guest-type adults kids time duration]} values
        voucher? (= guest-type "voucher")
        value {:start time
               :duration duration}
        slots (mf/with-memo
                [days day]
                (->> days
                     (filter #(= day (:day %)))
                     first
                     :slots
                     (filter #(visible-slot? guest-type %))
                     (map (fn [slot]
                            {:time (:from slot)
                             :label (:from slot)
                             :day day
                             :availability (:availability slot)
                             :vouchers-used (:vouchers-used slot)}))))
        adults (js/parseInt adults)
        kids (js/parseInt kids)
        persons (+ adults kids)
        limt-modal? (mf/use-state false)
        t (hooks/use-t "riverview")
        weekday (-> day
                    tick/date
                    tick/day-of-week
                    tick/int)
        weekday-slots-chart-data (->> (get slots-chart-data weekday)
                                      (sort-by (comp tick/time key)))]

    [:*
     [:& limit-modal
      {:opened @limt-modal?
       :on-close #(reset! limt-modal? false)}]

     [:& time-slot-modal
      {:slots slots
       :opened @modal?
       :set-value set-value
       :value value
       :persons persons
       :kids kids
       :voucher? voucher?
       :slots-chart-data weekday-slots-chart-data
       :on-close #(reset! modal? false)}]

     [:& form/field
      {:name [:main :time]
       :validate (fn [x] (when-not x [(t "time-required")]))
       :component ch/Input
       :cmp-params
       {:size :lg
        :text-align :center
        :font-size :3xl
        :line-height "49px"
        :pb "7px"
        :h "56px"
        :w "132px"
        :cursor :pointer
        :placeholder (t "select")
        :bg (when (:start value) "border-primary.500")
        :color (when (:start value) "white")
        :font-weight 500
        :sx {"&::placeholder" {:color "var(--chakra-colors-border-primary-500)"
                               :bg "white"
                               :font-size "20px"
                               :font-weight "bold"
                               :font-family "Abhaya Libre"}}
        :is-read-only true
        :on-click (fn [] (reset! modal? true))}}]

     (when (:duration value)
       [:> ch/Box {:text-align :center}
        [:> ch/Text {} (t "duration-header")]
        [:> ch/Text {:font-weight 700 :my 1} (format-duration2 (:duration value))]])]))

(mf/defc pool-pricing
  {::mf/register app/components
   ::mf/register-as :riverview/pool-pricing}
  [{:keys []}]
  (let [t (hooks/use-t "riverview")
        border (mf/html [:*
                         [:> ch/Box {:border-top "1px dashed" :my 2}]
                         [:> ch/Box {:border-top "1px dashed" :my 2}]
                         [:> ch/Box {:border-top "1px dashed" :my 2}]])]
    [:> ch/Box {:mb 4}
     [:> ch/SimpleGrid
      {:border "1px solid"
       :rounded :md
       :px 4
       :py 2
       :mt 5
       :columns 3
       :align-items :center}
      [:div]
      [:> ch/Text
       {:text-align :center}
       (t "pricing.included")]
      [:> ch/Text
       {:text-align :center}
       (t "pricing.next-hour")]
      border
      [:> ch/Text
       {:text-align :center
        :font-weight :bold}
       (t "pricing.hotel-guests")]
      [:> ch/Text
       {:text-align :center}
       (t "pricing.included-guest")]
      [:> ch/Text
       {:text-align :center}
       "50 PLN"]
      border
      [:> ch/Text
       {:text-align :center
        :font-weight :bold}
       (t "pricing.voucher")]
      [:> ch/Text
       {:text-align :center}
       (t "pricing.included-voucher")]
      [:> ch/Text
       {:text-align :center}
       "50 PLN"]]]))

(mf/defc terms-modal [{:keys [opened on-close]}]
  (let [t (hooks/use-t "riverview")]
    [:> ch/Modal
     {:is-open opened
      :on-close on-close}

     [:> ch/ModalOverlay {}]
     [:> ch/ModalContent {:my 8}
      [:> ch/ModalHeader {}
       [:> ch/Heading {:size :lg :align :center} (t "terms-link")]]
      [:> ch/ModalCloseButton {}]
      [:> ch/ModalBody {:text-align :center :px 16 :pb 4}
       [:> ch/Text {:color :brand.500 :mb 4 :white-space :pre-wrap :font-weight :bold} (t "terms.text1")]
       [:> ch/Flex {:justify :center}
        [:> ch/UnorderedList {}
         [:> ch/ListItem {} (t "terms.item1")]
         [:> ch/ListItem {} (t "terms.item2")]]]
       [:& pool-pricing {}]
       [:> ch/Text {} (t "terms.par1")]
       [:> ch/Text {:mb 4} [:> ch/Link {:text-decoration :underline :color :brand.500 :href "https://riverview.com.pl" :is-external true} [:b (t "terms.rv-link")]]]
       [:> ch/Text {:mb 4} (t "terms.par2")]
       [:& contact-links {}]]
      [:> ch/ModalFooter {:justify-content :center :pb 8}
       [:> ch/Button {:on-click on-close :size :lg :colorScheme "brand" :w "150px"}
        "Ok"]]]]))

(mf/defc terms-link
  {::mf/register app/components
   ::mf/register-as :riverview/terms-link}
  [{:keys [default-open]}]
  (let [terms-modal? (mf/use-state (boolean default-open))
        t (hooks/use-t "riverview")]
    [:*
     [:> ch/Link
      {:display :block
       :my 4
       :text-decoration :underline
       :text-align :center
       :on-click #(reset! terms-modal? true)}
      [:> ch/Icon {:as icons/FaInfoCircle :mr 2 :font-size "1.2em" :vertical-align :middle}]
      (t "terms-link")]

     [:& terms-modal
      {:opened @terms-modal?
       :on-close #(reset! terms-modal? false)}]]))

;; dd or merge with :info-popup (that is the same as link)
(mf/defc modal-button
  {::mf/register app/components
   ::mf/register-as :riverview/modal-button}
  [{:keys [button content]}]
  (let [modal? (mf/use-state false)
        t (hooks/use-t "riverview")]
    [:*
     [:> ch/Button
      {:on-click #(reset! modal? true)
       :size :lg
       :color-scheme "brand"
       :font-family "Abhaya Libre"
       :font-weight 800}
      (t button)]

     [:> ch/Modal
      {:is-open @modal?
       :on-close #(reset! modal? false)}

      [:> ch/ModalOverlay {}]
      [:> ch/ModalContent {}
       [:> ch/ModalHeader {}]
       [:> ch/ModalCloseButton {}]
       [:> ch/ModalBody {:text-align :center :px 16 :pb 4}
        (for [x content]
          (app/render-cmp x))]
       [:> ch/ModalFooter {:justify-content :center :pb 8}
        [:> ch/Button {:on-click #(reset! modal? false) :size :lg :colorScheme "brand" :w "150px"}
         "Ok"]]]]]))

(mf/defc rv-schedule
  {::mf/register app/components
   ::mf/register-as :riverview/schedule-button}
  [{:keys []}]
  (let [t (hooks/use-t "riverview")]
    [:> ch/Button
     {:size :lg
      :color-scheme "brand"
      :font-family "Abhaya Libre"
      :font-weight 800
      :white-space :pre-wrap
      :margin "8px auto"
      :display :flex
      :h "72px"
      :w "192px"
      :as "a"
      :href (t {:pl "https://riverview.com.pl/grafik",
                :en "https://riverview.com.pl/en/timetable/"})
      :justify-content :space-between
      :right-icon (mf/html [:& iconify/Icon
                            {:icon "material-symbols:tab-recent"
                             :width 40
                             :height 40}])}
     [:> ch/Box {:display :inline-block}]
     (t {:pl "Zobacz \ngrafik"
         :en "See \nTimetable"})]))

(def recommended-slots
  {#time/day-of-week "MONDAY" [["12:00" "13:00"] ["13:00" "14:00"] ["14:00" "15:00"]]
   #time/day-of-week "TUESDAY" [["09:00" "10:00"] ["12:00" "13:00"] ["15:00" "16:00"]]
   #time/day-of-week "WEDNESDAY" [["09:00" "10:00"] ["11:00" "12:00"] ["13:00" "14:00"]]
   #time/day-of-week "THURSDAY" [["09:00" "10:00"] ["12:00" "13:00"] ["13:00" "14:00"]]
   #time/day-of-week "FRIDAY" [["09:00" "10:00"] ["13:00" "14:00"] ["15:00" "16:00"]]
   #time/day-of-week "SATURDAY" [["07:00" "08:00"] ["12:00" "13:00"] ["13:00" "14:00"]]
   #time/day-of-week "SUNDAY" [["12:30" "13:30"] ["13:30" "14:30"] ["14:30" "15:30"]]})

(mf/defc slot
  {::mf/register app/components
   ::mf/register-as :riverview/slot}
  [{:keys [days slots-chart-data]}]
  (let [form-state (->clj (rff/useFormState))
        values (:main (:values form-state))
        t (hooks/use-t "riverview")
        voucher? (= (get-in values [:guest-type]) "voucher")
        day (get-in values [:day])
        dow (when day (tick/day-of-week (tick/date day)))
        disabled-days #{"2024-12-16" "2024-12-17"}
        diabled-voucher-days #{"2024-12-24" "2024-12-31" "2025-01-01"}]

    [:> ch/Box {}
     [:> ch/Box {}
      [:> ch/Text
       {:font-weight 600
        :align :left
        :my 4
        :ml 6}
       (t "date-header")]

      [:> ch/Box {:mx -4}
       [:& day-picker {:days days}]]]

     (cond
       (and voucher?
            (contains? diabled-voucher-days day))
       [:> ch/Box {}
        [:> ch/Text {}
         (t {:pl "Brak możliwości rezerwacji dla tej daty."
             :en "Reservation not available for this date."})]
        [:> ch/Box {:display :none}
         [:& time-slot-picker {:days days}]]]

       :else
       [:*
        (when (contains? disabled-days day)
          [:> ch/Box {}
           [:> ch/Text {:color :orange.600
                        :my 4
                        :white-space :pre-wrap}
            (t {:pl "Drodzy Goście\n"
                :en "Dear Guests,\n"})
            [:b (t {:pl "w dniach 16-19.12.2024 basen ze względu na modernizację będzie nieczynny. Jacuzzi i sauny pozostają dostępne.\n"
                    :en "the swimming pool will be closed for renovation from 16-19.12.2024. Jacuzzi and saunas remain open.\n"})]
            (t {:pl "Przepraszamy za wszelkie utrudnienia."
                :en "We apologize for any inconvenience."})]])
        (when (and (:day values)
                   (not (:time values)))
          [:> ch/Box {:my 6}
           [:> ch/Text {:color "#2E8540"}
            (t {:pl "Polecane przez nas godziny z najmniejszym obłożeniem:"
                :en "Our recommended hours with the lowest occupancy:"})]
           [:> ch/HStack {:color "#2E8540" :align :center :justify :center :gap 6}
            (for [[time1 time2] (get recommended-slots dow)]
              [:> ch/Text
               {:font-weight :bold}
               (str time1 "-" time2)])]])

        (when (:day values)
          [:> ch/Box {:text-align :center}
           [:> ch/Text
            {:font-weight 600
             :align :center
             :mt 8
             :mb 4}
            (t "time-header")]
           [:& time-slot-picker {:days days :slots-chart-data slots-chart-data}]])])]))

(mf/defc duration-step
  {::mf/register app/components
   ::mf/register-as :riverview/duration}
  [params]
  (let [form-state (->clj (rff/useFormState))
        form (rff/useForm)
        values (:main (:values form-state))
        set-value #(.change form "main.duration" %)
        t (hooks/use-t "riverview")
        days (:days params)
        day (:day values)
        time (:time values)
        adults (js/parseInt (:adults values))
        kids (js/parseInt (:kids values))
        persons (+ adults kids)
        last-time (mf/with-memo
                    [days day]
                    (or
                     (->> days
                          (filter #(= day (:day %)))
                          first
                          :slots
                          (filter #(<= time (:from %)))
                          (take-while #(<= persons (:availability %)))
                          last
                          :from)
                     time))
        max-duration (min 480
                          (+ 30 (tick/minutes
                                 (tick/between (tick/time time)
                                               (tick/time last-time)))))
        max-duration (if (= last-time "21:00") (+ 30 max-duration) max-duration) ;; hidden slot 21:30 -- to be removed
        min-duration (if (= "hotel" (:guest-type values)) 30 180)
        duration (or (:duration values) (min max-duration (if (= "hotel" (:guest-type values)) 60 180)))]
    (mf/use-effect
     (fn [] (when-not (:duration values) (set-value duration))))
    [:> ch/Flex
     {:justify :space-between
      :flex 1
      :direction :column}

     [:> ch/Box {}
      [:> ch/Heading
       {:size :md
        :align :center
        :my 4}
       (t "duration-header")]

      [:> ch/HStack
       {:justify :center
        :w :full}
       [:> ch/IconButton
        {:is-round true
         :size :lg
         :w "60px"
         :h "60px"
         :colorScheme "brand"
         :border "3px solid"
         :variant :outline
         :icon (mf/html [:> ch/Icon {:as icons/FaMinus}])
         :on-click #(set-value (- duration 30))
         :is-disabled (<= duration min-duration)}]
       [:> ch/VStack {:gap 1}
        [:> ch/Text
         {:font-size "50px"
          :font-weight 400
          :line-height "1em"
          :w "150px"
          :text-align :center}
         (format-duration duration)]
        [:> ch/HStack {:justify :space-around :w "90px"}
         [:> ch/Text {:font-weight 700} "h"]
         [:> ch/Text {:font-weight 700} "min"]]]
       [:> ch/IconButton
        {:is-round true
         :size :lg
         :w "60px"
         :h "60px"
         :colorScheme "brand"
         :border "3px solid"
         :variant :outline
         :icon (mf/html [:> ch/Icon {:as icons/FaPlus}])
         :on-click #(set-value (+ duration 30))
         :is-disabled (>= duration max-duration)}]]
      [:> ch/Text {:mt 4}
       (t {:pl "Minimalny czas na jaki można złożyć rezerwację to "
           :en "The minimum reservation time is "})
       [:b (format-duration2 min-duration)]]]]))

(mf/defc room-name-fields [params]
  (let [form (rff/useForm)
        t (hooks/use-t "riverview")
        required-f (fn [values]
                     (let [{:keys [room name]} (->clj values)]
                       (and
                        (or (not room)
                            (empty? room))
                        (or (not name)
                            (empty? name)))))]
    [:> ch/Box
     {:text-align :center
      :my 4}
     [:& form/field
      {:name [:main :name] #_(:name params)
       :validate (fn [x values]
                   (cond
                     (required-f values)
                     [(t "room-name-required")]))
       :component ch/Input
       :cmp-params
       {:size :lg
        :text-align :center
        :placeholder (t "name-placeholder")
        :font-size :4xl
        :h "80px"
        :w "100%"
        :type "text"}
       :label (mf/html
               [:> ch/FormLabel
                {:text-align :center
                 :mr 0}
                (t "whats-name")])}]
     [:> ch/Box {:h 8}]
     [:& form/field
      {:name [:main :room] #_(:name params)
       :validate (fn [x values]
                   (cond
                     (required-f values)
                     [(t "room-name-required")]
                     (and x (not (re-matches #"\d{3,4}" x)))
                     [(t "room-incorrect")]))
       :component ch/Input
       :cmp-params
       {:size :lg
        :text-align :center
        :placeholder "0000"
        :font-size :4xl
        :h "80px"
        :w "200px"
        :type "tel"
        :maxLength "4"}
       :label (mf/html
               [:> ch/FormLabel
                {:text-align :center
                 :mr 0}
                (t "whats-room")])}]]))

(mf/defc confirm-step
  {::mf/register app/components
   ::mf/register-as :riverview/room-name}
  [params]
  (let [form-state (->clj (rff/useFormState))
        values (:main (:values form-state))
        t (hooks/use-t "riverview")]
    [:> ch/Flex
     {:direction :column
      :flex 1
      :align :center
      :justify :space-between}
     [:> ch/Heading
      {:size :md
       :align :center
       :my 4}
      (t "confirm-header")]

     [:> ch/Box {}
      [:> ch/Heading {:mb 4}
       [:> ch/Icon {:as FiUsers :mr 8}]
       (string/capitalize (t "adults")) ": " (:adults values)
       (when (pos? (:kids values))
         (str ", " (string/capitalize (t "kids")) ": " (:kids values)))]

      [:> ch/Heading {:mb 4}
       [:> ch/Icon {:as FiCalendar :mr 8}]
       (slot-day-formatter2 (t "date-locale") (:day values))]

      [:> ch/Heading {:mb 4}
       [:> ch/Icon {:as FiClock :mr 8}]
       (let [t (:time values)
             [h m] (string/split t #":")]
         (str t " - " (inc (js/parseInt h)) ":" m)) ;; fixme
       ]]

     [:& room-name-fields {:name (:name params)}]]))

(def current-subscreen (s/atom :description))

(mf/defc thx-page
  {::mf/register app/components
   ::mf/register-as :riverview/thx-page}
  [params]
  (let [t (hooks/use-t "riverview")]
    (use-track "Riverview thx page" {})
    [:> ch/Container {}
     [:> ch/Flex {:direction :column
                  :justify :space-between
                  :p 4
                  :min-h "calc(100vh - 80px)"}
      [:> ch/Flex {:justify :space-between :w :full :align :center}
       [:& logo {:maxW 100 :mb 8 :alignSelf "start"}]
       [:& lang-button {}]]
      [:> ch/Heading
       {:text-align :center
        :size :lg}
       [:> Trans {} "riverview:thx.header"]]
      [:> ch/Text {:text-align :center
                   :font-size :lg
                   :my 4}
       (t "thx.par1")]

      [:> ch/Image
       {:src "/riverview/image2.jpg"
        :w "200px"
        :h "200px"
        :border-radius "50%"
        :align-self :center}]

      [:> ch/Box {:text-align :center}
       [:> ch/Text {:font-size :lg :my 4}
        (t "thx.par2")]
       [:> ch/Link {:href "tel:+48223288640"
                    :is-external true}
        [:> ch/Button {:colorScheme "brand"
                       :size :lg}
         [:> ch/Icon {:as FiPhone :mr 2}]
         "(+48) 22 328 8640"]]]]]))

(mf/defc offer-view-1
  {::mf/register app/components
   ::mf/register-as :riverview/offer-view-1}
  [{:keys [form provider] :as params}]
  (let [{:keys [t]} (hooks/use-translation)
        subpage #_(mf/use-state :form) (s/use-atom current-subscreen)
        show-form (mf/use-callback #(reset! subpage :form))]
    [:*
     (case @subpage
       :description
       (mf/html
        [:& description {:show-form show-form}])
       :form
       [:> ch/Box
        {:px 4}
        (app/render-cmp form)]
       :thx
       (mf/html
        [:& thx-page {}]))]))

(mf/defc rv-hstack
  {::mf/register app/components
   ::mf/register-as :riverview/hstack}
  [{:keys [children]}]
  [:> ch/HStack
   {:justify :space-around
    :align :center}
   (for [x children]
     (app/render-cmp x))])

(mf/defc kiosk-header
  [{:keys [pl en size gap? color align mb]}]
  [:> ch/Box {:text-align (or align "center")}
   [:> ch/Heading
    {:color (or color "#0F2E50")
     :white-space :pre-wrap
     :maxW 1100
     :mb (or mb (if gap? 12 2))
     :line-height (when-not gap? "1em")
     :font-size (case size
                  :big "64px"
                  :small "27px"
                  :button "48px"
                  "36px")
     :font-family (if (#{:big :button} size) "Abhaya Libre" "Raleway")
     :font-weight (if (#{:big :button} size) "800" "700")}
    pl]
   [:> ch/Heading
    {:color (or color "#0F2E50")
     :white-space :pre-wrap
     :maxW 1100
     :mb (or mb "20px")
     :font-size (case size
                  :big "56px"
                  :small "22px"
                  :button "42px"
                  "32px")
     :font-family (if (#{:big :button} size) "Abhaya Libre" "Raleway")
     :font-weight "500"}
    en]])

(mf/defc kiosk-slides
  [{:keys [states active]}]
  [:> ch/Box
   {:flex 1
    :w :full
    :position :relative}
   (for [[id children] states]
     [:> ch/ScaleFade
      {:in (= id active)
       :key id
       :initialScale 0
       :unmountOnExit true}
      [:> ch/Flex
       {:position :absolute
        :top 0
        :bottom 0
        :left 0
        :right 0
        :direction :column
        :align :center
        :justify :center
        :w :full}
       children]])])

(defn calc-time-left [start-time end-time]
  (if end-time
    (tick/between (tick/max (js/Date. start-time)
                            (js/Date.))
                  (js/Date. end-time))
    (tick/new-duration 0 :minutes)))

(defn calc-visit-duration [start-time]
  (tick/between (js/Date. start-time) (js/Date.)))

(defn calc-overtime
  [end-time]
  (when end-time
    (let [now (js/Date.)
          end (js/Date. end-time)
          diff (tick/between end now)
          zero (tick/new-duration 0 :minutes)
          grace (tick/new-duration constants/riverview-grace-period :minutes)]
      (if (or (neg? (.compareTo diff zero))
              (neg? (.compareTo diff grace)))
        zero
        (tick/- diff grace)))))

(defn exceeded-time [end-time]
  (if end-time
    (max
     0
     (-
      (tick/minutes
       (tick/between (js/Date. end-time) (js/Date.)))
      constants/riverview-grace-period))
    0))

(defn time-format [date]
  (->
   (js/Intl.DateTimeFormat
    "pl-PL"
    #js {:hour "numeric"
         :minute "numeric"})
   (.format (js/Date. date))))

(defn format-time-interval [from to]
  (str (time-format from) " - " (time-format to)))

(mf/defc visit-time-box' [{:keys [start-time end-time amount-due mode]}]
  (let [mode' mode
        mode (mf/use-state mode)
        update-counters (fn []
                          {:left (calc-time-left start-time end-time)
                           :duration (calc-visit-duration start-time)
                           :overtime (calc-overtime end-time)})
        counters (mf/use-state (update-counters))

        update-timer! (mf/use-callback
                       (mf/deps end-time)
                       (fn []
                         (reset! counters (update-counters))))
        start-timer! (fn []
                       (update-timer!)
                       (let [interval (js/setInterval update-timer! 1000)]
                         #(js/clearInterval interval)))
        header
        (case @mode
          :reservation
          {:pl "Czas w cenie Twojej rezerwacji:"
           :en "Time included in your reservation:"}
          :countdown
          {:pl "Pozostały czas:"
           :en "Time left:"}
          :status
          {:pl "Pozostały czas:"
           :en "Time left:"}
          :too-early
          {:pl "Twoja wizyta jest zaplanowana na:"
           :en "Your visit is scheduled for:"}
          :payment-required
          {:pl "Twoja wizyta jest zaplanowana na:"
           :en "Your visit is scheduled for:"}
          :too-late
          {:pl "Twoja wizyta była zaplanowana na:"
           :en "Your visit was scheduled for:"}
          :exceeded
          {:pl "Czas trwania wizyty:"
           :en "Visit duration:"}
          :payment
          {:pl "Do zapłaty:"
           :en "Amount due:"})

        minutes-left (tick/minutes (:left @counters 0))
        color (cond
                (= :too-late @mode) "#E07400"
                (< minutes-left 0) "#DC143C"
                (< minutes-left 16) "#E07400"
                :else "#2E8540")
        amount-due (or amount-due 0)]

    (mf/with-effect
      [mode']
      (reset! mode mode'))

    (mf/with-effect
      []
      (cond
        ;; start timer after 2s
        (= @mode :reservation)
        (let [clear (volatile! nil)]
          (js/setTimeout
           (fn []
             (reset! mode :countdown)
             (vreset! clear (start-timer!)))
           2000)
          (fn [] (when @clear (@clear))))
        (= @mode :status) (start-timer!)))

    (when (and start-time end-time)
      (let [format-amount-due (fn [amount]
                                (some-> amount (.toFixed 0)))
            format-counter-val (fn [val]
                                 (->> (or val 0)
                                      tick/seconds
                                      (max 0)
                                      format-duration-sec))
            grace-duration (tick/new-duration constants/riverview-grace-period :minutes)]
        [:> ch/Box
         {:border "4px solid #D1D1D1"
          :rounded "72px"
          :pt (if (#{:status :exceeded} @mode) 6 12)
          :px 2
          :pb 8
          :w "650px"
          :align :center
          :mb 5}
         [:& kiosk-header header]
         [:> ch/Text
          {:font-family "Abhaya Libre"
           :font-size "64px"
           :line-height "1em"
           :font-weight 800
           :color color}
          (case @mode
            (:reservation :payment-required :too-early :too-late) (format-time-interval start-time end-time)
            (:countdown :status) (format-counter-val (:left @counters))
            :exceeded (format-counter-val (tick/- (:duration @counters) grace-duration))
            :payment (str (format-amount-due amount-due) " PLN")
            "" #_(format-exceeded end-time))]
         [:> ch/Text {:font-family "Abhaya Libre" :font-size "32px" :font-weight 800 :color color}
          (when (and (= :exceeded @mode) (pos? amount-due))
            (str "(+ " (format-amount-due amount-due) " PLN)"))
          (when (= :payment @mode)
            (str "(+ " (format-counter-val (:overtime @counters)) " extra)"))]]))))

(mf/defc visit-time-box [{:keys [start-time end-time amount-due mode] :as args}]
  [:& visit-time-box'
   {:start-time start-time
    :end-time end-time
    :mode mode
    :amount-due amount-due
    :key (hash args)}])

(mf/defc network-activity-indicator [{:keys [loading?]}]
  (let [online? (mf/use-state js/navigator.onLine)
        update-online-status (fn []
                               (reset! online? js/navigator.onLine))
        offline? (not @online?)]
    (mf/use-effect
     (fn []
       (js/window.addEventListener "online" update-online-status)
       (js/window.addEventListener "offline" update-online-status)
       (fn []
         (js/window.removeEventListener "online" update-online-status)
         (js/window.removeEventListener "offline" update-online-status))))
    [:> ch/Box
     {:position :fixed
      :bottom 0
      :right 0
      :p 1}
     (when offline?
       [:> ch/Box
        {:px 1
         :opacity 0.5
         :background-color :red.600
         :rounded :md
         :shadow :base
         :font-size :lg
         :font-weight :semibold
         :color :white}
        "No connection"])
     (when loading?
       [:> ch/Box
        {:background-color :gray.50
         :rounded :md
         :shadow :base
         :font-size :sm
         :font-weight :semibold
         :color :gray.600}
        [:> ch/Spinner
         {:color :blue.500
          :vertical-align :middle}]])]))

(mf/defc kiosk-button [{:keys [pl en on-click color]}]
  [:> fm/motion.div
   {:whileTap #js {:scale 0.8}}
   [:> ch/Box
    {:on-click on-click
     :rounded "16px"
     :bg (or color "#0F2E50")
     :w "420px"
     :py "12px"}
    [:& kiosk-header
     {:pl pl
      :en en
      :mb 0
      :size :button
      :color "#fff"}]]])

(def sounds
  (memoize
   (fn []
     {:yes (js/Audio. "/riverview/sounds/yes.mp3")
      :no (js/Audio. "/riverview/sounds/no.mp3")
      :pay (js/Audio. "/riverview/sounds/pay.mp3")
      :end (js/Audio. "/riverview/sounds/end.mp3")})))

(mf/defc state-sounds [{:keys [state payment?]}]
  (let [{:keys [yes no end pay]} (sounds)]
    (mf/with-effect
      [state]
      (js/console.log "play sound" state)
      (cond
        (#{:started} state)
        (do
          (set! (.-currentTime yes) 0)
          (.play yes))
        (or (#{:payment-required} state) (and (#{:ended} state) payment?))
        (do
          (set! (.-currentTime pay) 0)
          (.play pay))
        (#{:ended} state)
        (do
          (set! (.-currentTime end) 0)
          (.play end))
        (#{:too-early :too-late :no-reservation} state)
        (do
          (set! (.-currentTime no) 0)
          (.play no))))
    [:div]))

(mf/defc pricing-notice []
  [:& kiosk-header
   {:pl "Każda kolejna rozpoczęta godzina: 50 PLN."
    :en "Every next started hour: 50 PLN."
    :size :small}])

(def test-card-id (s/atom-with-session-storage "test-card-id" ""))

(mf/defc card-debug-tool [{:keys [scan-fn]}]
  (let [card-atm (s/use-atom test-card-id)
        scan-fn (fn [card] (scan-fn (str "990000" card)))
        toast (ch/useToast)
        gate-scan (fn [reader card]
                    (->
                     (api/tx
                      :offer/tx
                      {:handler-id :kiosk/test-gate-scan
                       :offer-id "kiosk"
                       :provider-id "riverview"
                       :card-id (str "990000" card)
                       :reader-id reader})
                     (p/then
                      (fn [x]
                        (js/console.log "gate-scan response" x)
                        (if (:allowed x)
                          (toast #js {:title "OPEND" :status "success"})
                          (toast #js {:title "DENIED" :status "error"}))))))]
    [:> ch/HStack
     {:gap 1 :mb 3}
     [:> ch/Input
      {:placeholder "test room number"
       :w "200px"
       :value @card-atm
       :on-click (fn [e] (.stopPropagation e))
       :on-change (fn [e] (reset! card-atm (.-value (.-target e))))}]
     [:> ch/Button
      {:size :sm
       :on-click #(scan-fn @card-atm)}
      "kiosk scan"]
     [:> ch/Button
      {:size :sm
       :on-click #(gate-scan "IN-debug" @card-atm)}
      "gate in"]
     [:> ch/Button
      {:size :sm
       :on-click #(gate-scan "OUT-debug" @card-atm)}
      "gate out"]]))

(defn ms-to-next-3am []
  (let [now (js/Date.)
        target (js/Date. (.getFullYear now)
                         (.getMonth now)
                         (.getDate now)
                         3 0 0 0)]
    (when (<= (.getTime target) (.getTime now))
      (.setDate target (inc (.getDate target))))
    (- (.getTime target) (.getTime now))))

(defn use-daily-refresh!
  "Relaod kiosk screen every day at 3am.
  Useful to clear kiosk's state / fetch code updates as it keeps working 24/7."
  []
  (mf/use-effect
   []
   (letfn [(arm-refresh-timer! []
             (js/setTimeout
              #(.reload js/location true)
              (ms-to-next-3am)))]
     (let [arm-fn (arm-refresh-timer!)]
       (fn []
         (js/clearTimeout arm-fn))))))

(mf/defc kiosk-screen
  {::mf/register app/components
   ::mf/register-as :riverview/kiosk}
  [{:keys []}]
  (use-daily-refresh!)
  (let [state (mf/use-state :waiting)
        scan-id (mf/use-state nil)
        timer (mf/use-state nil)
        ref (mf/use-ref nil)
        loading? (mf/use-state false)
        reservation (mf/use-state nil)
        kiosk-id (:kiosk-id @(s/use-atom app/route-state) "")
        debug-tools? (= kiosk-id "test")

        scan-fn
        (fn [v]
          (js/console.log "scanned " v)
          (reset! loading? true)
          (->
           (api/tx
            :offer/tx
            {:handler-id :kiosk/card-scanned
             :offer-id "kiosk"
             :provider-id "riverview"
             :card v
             :kiosk-id kiosk-id})
           (p/then
            (fn [x]
              (js/console.log "scanned response" x)
              (reset! loading? false)
              (reset! scan-id (:scan_id x))
              (reset! reservation (:reservation x))
              (reset! state (:state x)))))

          (js/clearTimeout @timer)
          (reset! timer
                  (js/setTimeout
                   (fn []
                     (reset! loading? false)
                     (reset! reservation {})
                     (reset! state :waiting)
                     (reset! scan-id nil)
                     (.focus (.-current ref)))
                   5000)))

        end-visit-fn
        (fn []
          (api/tx
           :offer/tx
           {:handler-id :kiosk/end-visit
            :offer-id "kiosk"
            :provider-id "riverview"
            :kiosk-id kiosk-id
            :scan_id @scan-id})

          (reset! state :ended)

          (js/clearTimeout @timer)
          (reset! timer
                  (js/setTimeout
                   (fn []
                     (reset! reservation {})
                     (reset! state :waiting)
                     (reset! scan-id nil)
                     (.focus (.-current ref)))
                   5000)))

        clear-timeout (atom nil)
        input-fn (fn [e]
                   (let [el (.-target e)
                         v (.-value el)]
                     (js/clearTimeout @clear-timeout)
                     (reset! clear-timeout
                             (js/setTimeout
                              (fn []
                                (set! (.-value el) ""))
                              2000))
                     (when-let [m (re-matches #"(\w{14})" v)]
                       (reset! state :waiting)
                       (scan-fn (second m))
                       (.focus el))))]

    [:> ch/Flex
     {:align :center
      :text-align :center
      :direction :column
      :w "100vw"
      :h "$100vh"
      :on-click #(.focus (.-current ref))}

     [:link
      {:rel "stylesheet"
       :href "https://fonts.googleapis.com/css2?family=Raleway:wght@500..700"}]

     [:& state-sounds {:state @state
                       :payment? (pos? (:amount-due @reservation 0))}]

     [:& network-activity-indicator {:loading? @loading?}]

     [:> ch/Input
      {:ref ref
       :auto-focus true
       :on-input input-fn
       :w 0
       :h 0
       :position :absolute
       :left -100}]
     #_[:& logo {:maxW 165 :m "35px 0 50px"}]

     [:& kiosk-slides
      {:active @state
       :states
       {:waiting
        (mf/html
         [:> ch/VStack {:gap 20 :flex 1 :justify :center}

          ;; test buttons
          (when debug-tools?
            [:> ch/Box
             {:position :absolute :right 4 :top 4
              :border-color :yellow.500
              :border-width 2
              :p 2}
             [:& card-debug-tool {:scan-fn scan-fn}]
             [:> ch/HStack {:gap 1}
              [:> ch/Text {} "View state:"]
              [:> ch/Button
               {:size :sm
                :on-click (fn []
                            (reset! state :started)
                            (reset! reservation {:start-time (tick/at (tick/today)
                                                                      (tick/new-time (tick/hour (tick/now)) 0))
                                                 :end-time (tick/at (tick/today)
                                                                    (tick/new-time (inc (tick/hour (tick/now))) 0))}))}
               "start ok"]
              [:> ch/Button
               {:size :sm
                :on-click (fn []
                            (reset! state :too-early)
                            (reset! reservation {:start-time (tick/at (tick/today)
                                                                      (tick/new-time (+ 1 (tick/hour (tick/now))) 0))
                                                 :end-time (tick/at (tick/today)
                                                                    (tick/new-time (+ 2 (tick/hour (tick/now))) 0))}))}
               "start too early"]
              [:> ch/Button
               {:size :sm
                :on-click (fn []
                            (reset! state :payment-required)
                            (reset! reservation {:start-time (tick/at (tick/today)
                                                                      (tick/new-time (+ 1 (tick/hour (tick/now))) 0))
                                                 :end-time (tick/at (tick/today)
                                                                    (tick/new-time (+ 2 (tick/hour (tick/now))) 0))}))}
               "payment required"]
              [:> ch/Button
               {:size :sm
                :on-click (fn []
                            (reset! state :too-late)
                            (reset! reservation {:start-time (tick/at (tick/today)
                                                                      (tick/new-time (+ -1 (tick/hour (tick/now))) 0))
                                                 :end-time (tick/at (tick/today)
                                                                    (tick/new-time (+ (tick/hour (tick/now))) 0))}))}
               "start too late"]
              [:> ch/Button
               {:size :sm
                :on-click (fn []
                            (reset! state :no-reservation)
                            (reset! reservation {}))}
               "no reservation"]
              [:> ch/Button
               {:size :sm
                :on-click (fn []
                            (reset! state :ongoing)
                            (reset! reservation {:start-time (tick/at (tick/today)
                                                                      (tick/new-time (tick/hour (tick/now)) 0))
                                                 :end-time (tick/at (tick/today)
                                                                    (tick/new-time (inc (tick/hour (tick/now))) 0))}))}
               "ongoing"]
              [:> ch/Button
               {:size :sm
                :on-click (fn []
                            (reset! state :ongoing)
                            (reset! reservation {:start-time (tick/at (tick/today)
                                                                      (tick/new-time (+ -2 (tick/hour (tick/now))) 0))
                                                 :amount-due 50
                                                 :end-time (tick/at (tick/today)
                                                                    (tick/new-time (+ -1 (int (tick/hour (tick/now)))) 0))}))}
               "ongoing exceeded"]]])

          [:> ch/Box {:position :relative}
           [:& kiosk-header
            {:pl "Rozpocznij / Zakończ wizytę"
             :en "Start / End your visit"
             :size :big}]
           [:> ch/Box
            {:position :absolute
             :right -40
             :top 2}
            [:& iconify/Icon
             {:icon "material-symbols:double-arrow-rounded"
              :color "#0F2E50"
              :width 120
              :height 120}]]]
          [:> ch/Box {}
           [:& kiosk-header
            {:pl "Przyłóż kartę pokojową do czytnika\n po prawej stronie, aby rozpocząć i zakończyć wizytę."
             :en "Place room card on the reader on the right\n to start and end your visit."
             :gap? true}]]])

        :started
        (mf/html
         [:> ch/VStack {:gap 10}
          [:& kiosk-header
           {:pl "Wizyta rozpoczęta."
            :en "Your visit has started."
            :size :big}]

          [:& visit-time-box
           {:start-time (:start-time @reservation)
            :end-time (:end-time @reservation)
            :mode :reservation}]

          [:& pricing-notice {}]])

        :payment-required
        (mf/html
         [:> ch/VStack {:gap 5}
          [:& kiosk-header
           {:pl "Wymagana płatność za rezerwację."
            :en "Payment required for your reservation."
            :color "#E07400"
            :size :big}]

          [:& kiosk-header
           {:pl "Dokonaj płatności na recepcji."
            :en "Make payment at the front desk."}]

          [:& visit-time-box
           {:start-time (:start-time @reservation)
            :end-time (:end-time @reservation)
            :mode :payment-required}]])

        :too-early
        (mf/html
         [:> ch/VStack {:gap 5}
          [:& kiosk-header
           {:pl "Zbliżająca się rezerwacja."
            :en "Upcoming reservation."
            ;:color "#DC143C"
            :size :big}]

          [:& visit-time-box
           {:start-time (:start-time @reservation)
            :end-time (:end-time @reservation)
            :mode :too-early}]])

        :too-late
        (mf/html
         [:> ch/VStack {:gap 5}
          [:& kiosk-header
           {:pl "Wizyta rozpocznie się z opóźnieniem."
            :en "Your visit will start with a delay."
            :color "#E07400"
            :size :big}]

          [:& kiosk-header
           {:pl "Poproś o pomoc na recepcji."
            :en "Ask for assistance at the front desk."}]

          [:& visit-time-box
           {:start-time (:start-time @reservation)
            :end-time (:end-time @reservation)
            :mode :too-late}]])

        :no-reservation
        (mf/html
         [:> ch/VStack {:gap 5}
          [:& kiosk-header
           {:pl "Wymagana rezerwacja."
            :en "Reservation required."
            :color "#DC143C"
            :size :big}]

          [:& kiosk-header
           {:pl "Zeskanuj kod QR i zarezerwuj miejsce."
            :en "Scan QR code and make reservation."}]

          [:> qr/default
           {:value (string/replace js/location.href "/kiosk" "/pool")
            :size 230
            :fgColor "#0F2E50"}]])

        :ongoing
        (let [exceeded? (pos? (exceeded-time (:end-time @reservation)))]
          (mf/html
           [:> ch/VStack {:gap 5 :mt -10}
            (if exceeded?
              [:& kiosk-header
               {:pl "Wizyta wydłużona."
                :en "Your visit has been extended."
                :size :big}]
              [:& kiosk-header
               {:pl "Wizyta w toku."
                :en "Your visit continues."
                :size :big}])

            [:& visit-time-box
             {:start-time (:start-time @reservation)
              :end-time (:end-time @reservation)
              :amount-due (:amount-due @reservation)
              :mode (if exceeded? :exceeded :status)}]

            [:& pricing-notice {}]

            [:& kiosk-button
             {:pl "Zakończ wizytę"
              :en "End visit"
              :on-click end-visit-fn}]]))

        :ended
        (let [exceeded? (pos? (:amount-due @reservation 0))]
          (mf/html
           [:> ch/VStack {:gap 5}
            [:& kiosk-header
             {:pl "Dziękujemy za wizytę!"
              :en "Thank you for your visit!"
              :size :big}]
            (if exceeded?
              [:& kiosk-header
               {:pl "Prosimy o opłacenie dodatkowego czasu w recepcji."
                :en "Please settle charges for extended visit time at the front desk."}]
              [:& kiosk-header
               {:pl "Zapraszamy ponownie!"
                :en "We hope to see you again!"}])
            (when exceeded?
              [:& visit-time-box
               {:start-time (:start-time @reservation)
                :end-time (:end-time @reservation)
                :amount-due (:amount-due @reservation)
                :mode :payment}])
            [:> ch/Box {:mt 10 :mr 1}
             [:& iconify/Icon
              {:icon "material-symbols:emoji-people"
               :color "#0F2E50"
               :width 106
               :height 106}]]]))}}]]))

(mf/defc service-box
  {::mf/register app/components
   ::mf/register-as :riverview/service-box}
  [{:keys [title desc image]}]
  (let [t (hooks/use-t "offer")]
    [:> ch/Box
     {:rounded :lg
      :border "1px solid var(--chakra-colors-brand-500)"
      :text-align :center
      :p 3
      :my 4}

     (when image
       [:> ch/Box
        {:w "100%"
         :aspect-ratio "3 / 2"
         :border "1px solid var(--chakra-colors-brand-500)"
         :rounded :lg
         :mb 4
         :overflow :hidden}
        [:> ch/Image
         {:src image
          :w "100%"
          :h "100%"
          :object-fit :cover}]])

     [:> ch/Heading
      {:size :lg}
      [:> ch/Box ; LinkOverlay
               ;{:href href}
       {}
       (t title)]]

     [:> ch/Text
      {:mt 2
       :white-space :pre-wrap}
      (t desc)]]))

(mf/defc club-box
  {::mf/register app/components
   ::mf/register-as :riverview/club-box}
  [{:keys [icon desc bg?]}]
  (let [t (hooks/use-t "offer")]
    [:> ch/HStack
     {:rounded :lg
      :text-align :center
      :px 1
      :py 2
      :my 2
      :align :center
      :bg (if bg? "#FFF9EB" "white")
      :border (when-not bg? "1px solid #FFD46C")}

     [:> ch/Box {:w "28px"}
      [:& iconify/Icon
       {:icon icon
        :color "#FFD46C"
        :width 28
        :height 28}]]

     [:> ch/Text
      {:flex 1
       :px 2
       :font-weight "500"
       :white-space :pre-wrap}
      (t desc)]]))

(mf/defc summary-box [{:keys [values total]}]
  (let [t (hooks/use-t "riverview")]
    [:> ch/Box
     {:border "1px solid"
      :border-color :brand.500
      :rounded :md
      :p 4
      :min-w 250
      :max-w 300
      :w :full
      :text-align :left
      :margin "16px auto"}
     [:> ch/Text
      {:font-weight :bold}
      (case (:guest-type values)
        "hotel" (t {:pl "Rezerwacja na pokój"
                    :en "Reservation for the room"})
        "voucher" "Voucher"
        nil "")]
     (when (:room values)
       [:> ch/Text {}
        (t "room") ": " [:b (:room values)]])
     [:> ch/Text {}
      (t "adults") ": " [:b (:adults values)]]
     (when (pos? (:kids values))
       [:> ch/Text {}
        (t "kids") ": " [:b (:kids values)]])
     (when (:day values)
       [:> ch/Text {}
        (t "date") ": " [:b (slot-day-formatter2 (t "date-locale") (:day values))]])
     [:> ch/Text {}
      (t "time") ": " [:b (:time values)]]
     [:> ch/Text {}
      (t "duration") ": " [:b (format-duration2 (:duration values))]]

     (when (pos? total)
       [:*
        [:> ch/Box {:border "1px dashed" :my 2}]
        [:> ch/Text
         {:font-weight :bold
          :text-align :center
          :font-size :lg
          :mt 4}
         (str (fablo-offers.app.components.form/format-money total) " PLN")]])]))

(mf/defc confirmation
  {::mf/register app/components
   ::mf/register-as :riverview/pool-confirmation}
  [{:keys [footnote]}]
  (let [t (hooks/use-t "riverview")
        values (:values (->clj (rff/useFormState)))
        {:keys [offer-id provider-id order-form-state]} (mf/use-ctx fablo-offers.app.components.form/offer-ctx)
        summary-query (s/use-query ["preorder-summary"]
                                   #(api/tx :offer/tx (merge values
                                                             {:handler-id :order/preorder-summary
                                                              :offer-id offer-id
                                                              :provider-id provider-id}))
                                   {})
        {:keys [total duration-within-free-limit? free-pool-used?]} (:data summary-query)
        vals (:main values)
        order-form-state-atm (s/use-atom order-form-state)
        with-payment? (pos? total)]
    (mf/with-effect
      [with-payment?]
      (swap! order-form-state-atm assoc :with-payment? with-payment?))
    ;; (js/console.log "values" vals)
    [:> ch/Flex {:direction :column :flex 1}
     [:> ch/Heading {:size :md :mt 8 :mb 4} (t "summary")]
     (when (:isLoading summary-query)
       [:> ch/Spinner {:align-self :center :my 4}])

     [:& summary-box
      {:values vals
       :total total}]

     [:> ch/Text
      {:font-size :xs
       :font-weight :medium}
      (if with-payment?
        (t :click-confirm-and-pay)
        (t :click-confirm-and-order))]

     (when (and duration-within-free-limit?
                free-pool-used?)
       [:& form/field
        {:name "free-pool-info-accepted?"
         :component ch/Checkbox
         :type "checkbox"
         :validate (fn [value _form-values]
                     (when-not value
                       [(t "accept-required")]))
         :initialValue false
         :cmp-params {:max-width 300
                      :margin "0 auto"
                      :align-items :start
                      :text-align :start
                      :children
                      (mf/html
                       [:> ch/Text {}
                        [:style ".chakra-checkbox__control { margin-top: 4px; }"]
                        (t "free-pool-info")])}}])

     (when (= "voucher" (:guest-type vals))
       [:> ch/HStack {:align-items :flex-start :mt 8}
        [:& iconify/Icon
         {:icon "material-symbols:info-outline"
          :width 24
          :height 24}]
        [:> ch/Text {:text-align :left
                     :font-weight 500
                     :flex 1}
         (t {:pl "Prosimy o posiadanie oryginalnego zakupionego vouchera lub jego wersji elektronicznej (PDF) w celu skorzystania z basenu."
             :en "Please have the original purchased voucher or its electronic version (PDF) with you to access the pool."})]])]))

;; fixme
(defn date-time-format [d]
  (let [d (js/Date. d)]
    (str
     (string/replace (.toLocaleTimeString d) #":\d\d$" "")
     ", "
     (.toLocaleDateString d))))

(mf/defc pool-order-status
  {::mf/register app/components
   ::mf/register-as :riverview/pool-order-status}
  [{:keys [provider offer offline-payment? thx-text thx-header order claim] :as params}]
  (let [t (hooks/use-t "riverview")
        status (:order/status order)
        order-state (:order/state order)
        short-id (-> (:order/id order) (.substr 0 4) (.toUpperCase))]
    [:> ch/Box {}
     [:& app/parallax-image-card
      {:top-space 72
       :image (get-in provider [:provider/business-info :background-image])}

      [:> ch/Box {:py 4}
       [:> ch/Heading
        {:size :lg :mb 4 :text-align :center}
        (t (:offer/name offer))]

       [:> ch/HStack
        {:w :full
         :justify :space-between
         :mb 6}
        [:> ch/Text {:font-size :sm} (t {:en "Order #" :pl "Zamówienie #"}) short-id]
        [:> ch/Text {:font-size :sm} (date-time-format (:order/created-at order))]]

       (case status
         :cancelled
         [:> ch/Box {}
          [:> ch/Flex
           {:color :red.500
            :font-size :lg
            :justify :center
            :align :center
            :font-weight :semibold}
           [:> ch/Icon {:as icons/FaTimesCircle
                        :mr 4
                        :font-size :2xl}]
           "Anulowane"]
          [:> ch/Text
           {:align :center
            :mt 4}
           [:b "Powód:"] [:br]
           (t (:order/cancellation-reason order-state))]]

         [:> ch/VStack
          {:text-align :center
           :px 8
           :gap 4}

          [:> ch/VStack {}
           [:& iconify/Icon
            {:icon "material-symbols-light:check-circle"
             :color "#2E8540"
             :width 64
             :height 64}]
           [:> ch/Text
            {:color "#2E8540"
             :font-weight :bold}
            (t {:en "Reservation confirmed."
                :pl "Wizyta zarezerwowana."})]]
          [:> ch/Text
           {:font-weight :bold}
           (t {:en "Thank you!"
               :pl "Dziękujemy!"})]

          [:> ch/Text
           {:font-weight :bold}
           (t {:pl "Prosimy o punktualne przybycie na basen, aby uniknąć utraty rezerwacji."
               :en "We kindly request that you arrive on time at the pool to avoid losing your reservation."})]

          [:> ch/Text
           {}
           (t {:en "Reservation confirmation has been sent to your email address."
               :pl "Potwierdzenie rezerwacji zostało wysłane na Państwa adres e-mail."})]
          (when offline-payment?
            [:> ch/Text
             {:color "#E07400"
              :font-weight :bold}
             (t {:en "Settle payment at the RVWC reception before start of your visit."
                 :pl "Dokonaj płatności w recepcji RVWC przed rozpoczęciem wizyty."})])
          [:> ch/Text
           {:white-space :pre-wrap}
           (t {:en "See you at \nRiver View Wellness Centre."
               :pl "Do zobaczenia \nw River View Wellness Centre."})]

          [:& summary-box
           {:values claim}]])]]]))
